import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function InstitutionalNeedsAssessment() {
  return (
    <div className="art-page">
      <SEO
        title="Clean Cooking Energy Needs Assessment — Public and Private Institutions (MEMD / World Bank)"
        description="From August 2022 to June 2023, CIRCODU undertook a comprehensive Clean Cooking Energy Needs Assessment across public and private institutions in Uganda, commissioned by the Ministry of Energy and Mineral Development (MEMD) with World Bank support."
        keywords="clean cooking energy needs assessment, public institutions, private institutions, MEMD, World Bank, Uganda, institutional energy assessment, clean cooking technologies, institutional cookstoves, institutional biogas systems, LPG, institutional energy needs Uganda, clean cooking needs assessment Uganda, MEMD clean cooking assessment Uganda, World Bank clean cooking assessment Uganda, institutional energy transition Uganda, clean cooking investment planning Uganda, institutional energy data Uganda, environmental and social safeguards Uganda, institutional energy infrastructure Uganda"
        url="/Clean-Cooking-Energy-Needs-Assessment-Public-and-Private-Institutions-MEMD-World-Bank"
        datePublished="2023-06-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Clean Cooking Energy Needs Assessment — Public and Private
              Institutions (MEMD/World Bank)
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              June 01, 2023
            </div>
            <h1 className="art-title">
              Clean Cooking Energy Needs Assessment — Public and Private
              Institutions (MEMD / World Bank)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                From August 2022 to June 2023, CIRCODU undertook a comprehensive{" "}
                <strong>Clean Cooking Energy Needs Assessment</strong> across
                public and private institutions in Uganda, commissioned by the{" "}
                <strong>
                  Ministry of Energy and Mineral Development (MEMD)
                </strong>{" "}
                with <strong>World Bank</strong> support. One of the most
                extensive institutional energy assessments ever conducted in
                Uganda, its findings directly supported the design of investment
                programmes to transition hospitals, schools, prisons, and other
                public institutions from biomass to cleaner cooking
                technologies.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU's work operated across three interconnected dimensions:
              </p>
              <ol>
                <li>
                  <strong>Awareness-raising:</strong> Working directly with
                  institutional decision-makers to communicate the availability,
                  performance, and benefits of clean cooking technologies —
                  including institutional cookstoves, institutional biogas
                  systems, and LPG — building the institutional appetite for
                  technology transitions.
                </li>
                <li>
                  <strong>Energy needs assessments:</strong> Detailed
                  characterisation of current fuel use and cooking
                  infrastructure for each participating institution; projection
                  of future cooking energy requirements; and financial and
                  economic analysis establishing the investment case for each
                  technology option. This gave MEMD and the World Bank the
                  granular data needed to prioritise investments and structure
                  financing packages.
                </li>
                <li>
                  <strong>Environmental and Social Safeguards:</strong>{" "}
                  Development and application of site-specific safeguards
                  checklists for each institution, assessing potential adverse
                  and beneficial impacts associated with introducing new cooking
                  technologies and ensuring compliance with World Bank
                  environmental and social standards.
                </li>
              </ol>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's institutional energy
                assessments, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
